
import React, { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import HeaderPartDumas from './HeaderPartDumas';
import { BASE_URL, BASE_URL_PUBLIC } from "../Components/config/keys";
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function getButtonStyle(isMobile, side) {
    return {
        position: 'absolute',
        top: isMobile ? '72px' : '50%',
        transform: isMobile ? 'none' : 'translateY(-50%)',
        zIndex: 10,
        width: isMobile ? '48px' : '58px',
        height: isMobile ? '48px' : '58px',
        borderRadius: '50%',
        backgroundColor: 'rgba(50, 64, 97, 0.88)',
        color: '#fff',
        border: 'none',
        fontSize: isMobile ? '1.6rem' : '2rem',
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: 0,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.18)',
        left: side === 'left' ? (isMobile ? '32px' : '16px') : 'auto',
        right: side === 'right' ? (isMobile ? '32px' : '16px') : 'auto',
    };
}

function CarouselWithButtons({ children, numItems, isMobile }) {
    const [index, setIndex] = useState(0);
    const handlePrev = () => setIndex(i => (i - 1 + numItems) % numItems);
    const handleNext = () => setIndex(i => (i + 1) % numItems);
    return (
        <div style={{ position: 'relative' }}>
            <Carousel activeIndex={index} onSelect={setIndex} indicators={false} controls={false}>
                {children}
            </Carousel>
            <button type="button" aria-label="Previous slide" onClick={handlePrev} style={getButtonStyle(isMobile, 'left')}>&#8249;</button>
            <button type="button" aria-label="Next slide" onClick={handleNext} style={getButtonStyle(isMobile, 'right')}>&#8250;</button>
        </div>
    );
}

const PartDumas = () => {
    const { t, i18n } = useTranslation();
    const [news, setNews] = useState([]);
    const [historic, setHistoric] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseNews = await axios.get(`${BASE_URL}prat-dumas-by-type/news?lang=${i18n.language}`);
                const sortedNews = responseNews.data.data.sort((a, b) => new Date(b.date) - new Date(a.date));
                
                const responseHistoric = await axios.get(`${BASE_URL}prat-dumas-by-type/historic?lang=${i18n.language}`);
                setNews(sortedNews);
                setHistoric(shuffleArray(responseHistoric.data.data));
            } catch (error) {
                console.error('Error fetching data:', error);
                // Handle error here (show error message or other logic)
            }
        };
    
        fetchData();
    }, [i18n.language]);

    const shuffleArray = (array) => {
        let shuffledArray = array.slice(); // Create a copy of the array
        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
        }
        return shuffledArray;
    };

    const renderCarouselItems = (items, numColumns) => {
        // Filtrer les items pour ne garder que ceux qui ont un ID valide
        const filteredItems = items.filter(item => item.id);
    
        // Tableau pour stocker tous les items à afficher, y compris les vides si nécessaire
        let renderedItems = [];
    
        for (let index = 0; index < filteredItems.length; index += numColumns) {
            renderedItems.push(
                <Carousel.Item key={index}>
                    <div className="container">
                        <div className="row">
                            {Array.from({ length: numColumns }).map((_, colIndex) => {
                                const itemIndex = (index + colIndex) % filteredItems.length;
                                const item = filteredItems[itemIndex];
                                return (
                                    <div className="col-md-4 mb-4" key={colIndex}>
                                        <div className="card h-100 border-0">
                                            <Link to={`/prat_dumas_detail/${item.id}`} className="text-decoration-none">
                                                <img
                                                    className="card-img-top img-fluid"
                                                    src={`${BASE_URL_PUBLIC}uploads/photos/homapage/${item.id}/${item.piece_joint}`}
                                                    alt={`Card ${colIndex + 1}`}
                                                    style={{ height: "193px", width: "100%", objectFit: 'cover' }}
                                                    onError={(e) => { e.target.onerror = null; e.target.src = '/path/to/default/image.jpg'; }}
                                                />
                                            </Link>
                                            <div className="card-body">
                                                <Link to={`/prat_dumas_detail/${item.id}`} className="text-decoration-none">
                                                    <p className='mb-0 mt-3 fw-bold title_card' style={{ color: '#04D9D9' }}>{item.title}</p>
                                                </Link>
                                                <p dangerouslySetInnerHTML={{ __html: item.petit_description }}></p>
                                            </div>
                                            <div className="card-footer bg-transparent d-flex justify-content-end align-items-center">
                                                <Link className="btn btn-primary mt-3"
                                                    to={`/prat_dumas_detail/${item.id}`}
                                                    style={{ backgroundColor: '#04D9D9', color: 'white', border: 'none' }}>
                                                    {t('Voir')} <FontAwesomeIcon icon={faEye} className="ms-2" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Carousel.Item>
            );
        }
    
        return renderedItems;
    };

    const isMobile = window.innerWidth <= 768;
    const numColumns = isMobile ? 1 : 3;

    if (news.length === 0 || historic.length === 0) {
        return <div>Loading...</div>;
    }

    const newsItems = renderCarouselItems(news, numColumns);
    const historicItems = renderCarouselItems(historic, numColumns);

    return (
        <>
            <HeaderPartDumas />
            <section className="py-0 pb-5">
                <div className="container pb-5">
                    <h2 className="h4 fw-bolder pt-5" style={{ color: '#324061' }}>{t('Our Actuality')}</h2>
                </div>
                <CarouselWithButtons numItems={newsItems.length} isMobile={isMobile}>
                    {newsItems}
                </CarouselWithButtons>
            </section>
            <section className="py-0 pb-5">
                <div className="container pb-5">
                    <h2 className="h4 fw-bolder" style={{ color: '#324061' }}>{t('Our History')}</h2>
                </div>
                <CarouselWithButtons numItems={historicItems.length} isMobile={isMobile}>
                    {historicItems}
                </CarouselWithButtons>
            </section>
        </>
    );
}

export default PartDumas;
